import { Drawer } from "antd";
import { Formik } from "formik";
import { MdOutlineAttachFile, MdOutlineEmail, MdSend } from "react-icons/md";
import Input from "shared/components/Input";
import { bindInputProps } from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import { PROPOSAL_ATTACHMENTS } from "../proposalAttachments";

const BODY_ROWS = 12;

const ProposalDrawer = ({
  translation: T,
  open,
  onClose,
  proposal,
  onSubmit,
  saving,
}) => (
  <Drawer
    className="drawer__area ac-collectif__proposal-drawer"
    title={T.SUMMARY.PROPOSAL.TITLE}
    width={640}
    onClose={onClose}
    open={open}
    placement="right"
  >
    <Formik initialValues={proposal} onSubmit={onSubmit}>
      {({ values, handleSubmit, ...formProps }) => (
        <div className="ac-collectif__proposal">
          <p className="ac-collectif__proposal-description">
            {T.SUMMARY.PROPOSAL.DESCRIPTION}
          </p>
          <Input
            required
            type="email"
            icon={<MdOutlineEmail size={22} />}
            label={T.SUMMARY.PROPOSAL.RECIPIENT.LABEL}
            placeholder={T.SUMMARY.PROPOSAL.RECIPIENT.PLACEHOLDER}
            {...bindInputProps({ name: "recipient", values, ...formProps })}
          />
          <Input
            required
            icon={<MdOutlineEmail size={22} />}
            label={T.SUMMARY.PROPOSAL.SUBJECT.LABEL}
            placeholder={T.SUMMARY.PROPOSAL.SUBJECT.PLACEHOLDER}
            {...bindInputProps({ name: "subject", values, ...formProps })}
          />
          <Input
            required
            type="textarea"
            rows={BODY_ROWS}
            label={T.SUMMARY.PROPOSAL.BODY.LABEL}
            placeholder={T.SUMMARY.PROPOSAL.BODY.PLACEHOLDER}
            {...bindInputProps({ name: "body", values, ...formProps })}
          />

          <div className="ac-collectif__proposal-attachments">
            <h4 className="ac-collectif__proposal-attachments-title">
              {T.SUMMARY.PROPOSAL.ATTACHMENTS.TITLE}
            </h4>
            <p className="ac-collectif__proposal-attachments-description">
              {T.SUMMARY.PROPOSAL.ATTACHMENTS.DESCRIPTION}
            </p>
            <ul className="ac-collectif__proposal-attachments-list">
              {PROPOSAL_ATTACHMENTS.map((attachment) => (
                <li
                  className="ac-collectif__proposal-attachments-item"
                  key={attachment.key}
                >
                  <MdOutlineAttachFile size={18} />
                  <span>
                    <strong>{attachment.name}</strong>
                    <span>{attachment.size}</span>
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <ActionButtons
            onBack={onClose}
            onSubmit={handleSubmit}
            loading={saving}
            disabled={{ next: saving }}
            icons={{ next: <MdSend size={16} /> }}
            translation={{
              PREVIOUS: T.ACTIONS.CANCEL,
              NEXT: T.SUMMARY.PROPOSAL.SUBMIT,
            }}
          />
        </div>
      )}
    </Formik>
  </Drawer>
);

export default ProposalDrawer;
